import { doc, collection, setDoc } from 'firebase/firestore'
import { db } from './../services/database'

const reviewsRef = collection(db, "Reviews")

export function addReview(data) {
    let docId = doc(reviewsRef).id
    return setDoc(doc(reviewsRef, docId), { ...data, createdAt: Date.now(), id: docId })
}

// function reviewsRef(id) {
//     return doc(db, "Influencers", id)
// }

// waitForInterval(fn, secs) {
//     return new Promise((resolve) => {
//       setTimeout(() => {
//         fn();
//         return resolve();
//       }, secs);
//     });
//   },

// google.maps.event.addListener(marker, "dragend", function (event) {
//     var position = event.latLng;
//     new google.maps.Geocoder().geocode(
//       {
//         // latLng: marker.getPosition(),
//         latLng: position,
//       },
//       function (results, status) {
//         if (status === google.maps.GeocoderStatus.OK) {
//           if (results[1]) {
//             self.currentAddress = results[1].formatted_address;
//             self.searchText = self.currentAddress;
//             self.mapLocation = {
//               lat: position.lat(),
//               lng: position.lng(),
//             };
//           } else {
//             alert("No results found");
//           }
//         } else {
//           alert("Geocoder failed due to: " + status);
//         }
//       }
//     );
//   });